// Curated finger → planet → adornment guide (from the Navratan reference,
// blended with accessible crystal lore, framed as tradition — not prescription).
// Shared shape mirrored in backend services.py ADORNMENTS for the emailed report.
export const ADORNMENTS = [
  {
    finger: "Index finger",
    planet: "Jupiter",
    color: "#B5872B",
    energy: "Wisdom, abundance & leadership",
    stones: "Lapis Lazuli, or Yellow Sapphire",
    metal: "Gold",
    note: "Adorn it to invite expansion — to say yes to your own bigness.",
  },
  {
    finger: "Middle finger",
    planet: "Saturn",
    color: "#556070",
    energy: "Boundaries, discipline & protection",
    stones: "Tiger's Eye or Onyx (Blue Sapphire in the Vedic line)",
    metal: "Silver or steel",
    note: "A ring here guards your center — good boundaries you can wear.",
  },
  {
    finger: "Ring finger",
    planet: "Sun & Mars",
    color: "#B5502B",
    energy: "Creativity, vitality, recognition & love",
    stones: "Carnelian, or Ruby / Red Coral",
    metal: "Gold or copper",
    note: "Adorn it to warm what you make and who you love.",
  },
  {
    finger: "Little finger",
    planet: "Mercury & Moon",
    color: "#3E7A72",
    energy: "Communication, intellect & intuition",
    stones: "Moonstone, or Emerald / Pearl",
    metal: "Silver",
    note: "A ring here sharpens the voice and steadies the tides of feeling.",
  },
  {
    finger: "Thumb",
    planet: "the seat of will",
    color: "#8A7D5F",
    energy: "Willpower & vitality",
    stones: "Left bare by tradition",
    metal: "—",
    note: "Tradition leaves the thumb unringed, so your will stays free to act.",
  },
];
